export default "__VITE_ASSET__CGRe$BJO__"